import mock from './mock';

import doc from './api.doc';
import groups from './api.groups';
import permissions from './api.permissions';

const config = Object.freeze({
  login: {
    desc: '登录',
    method: 'post',
    url: '/api/auth/login',
    mock: false,
    request: {},
    response: mock.login,
  },
  logout: {
    desc: '登出',
    method: 'post',
    url: '/api/auth/logout',
    mock: false,
    request: {},
    response: mock.logout,
  },
  validatePassword: {
    desc: '密码验证',
    method: 'post',
    url: 'api/v1/users/password/validate',
    mock: false,
    request: {},
    response: mock.validatePassword,
  },
  updatePassword: {
    desc: '更新密码',
    method: 'post',
    url: 'api/v1/users/password/update',
    mock: false,
    request: {},
    response: mock.updatePassword,
  },
  getEmailCode: {
    desc: '获取邮件验证码',
    method: 'post',
    url: 'api/forgot/code/gen',
    mock: false,
    request: {},
    response: mock.getEmailCode,
  },
  emailCodeValidate: {
    desc: '验证邮件验证码',
    method: 'post',
    url: 'api/forgot/code/check',
    mock: false,
    request: {},
    response: mock.emailCodeValidate,
  },
  forgotPassword: {
    desc: '验证邮件验证码',
    method: 'post',
    url: 'api/forgot/password/reset',
    mock: false,
    request: {},
    response: mock.forgotPassword,
  },
  getUserInfo: {
    desc: '获取用户数据',
    method: 'get',
    url: 'api/v1/users/me',
    mock: false,
    request: {},
    response: mock.getUserInfo,
  },

  getAllUsers: {
    desc: '获取lp management users列表',
    method: 'get',
    url: 'api/v1/lps',
    mock: false,
    request: {},
    response: mock.getAllUsers,
  },
  createLp: {
    desc: 'add lp',
    method: 'post',
    url: 'api/v1/lp',
    mock: false,
    request: { lp_name: '' },
    response: mock.createFolder,
  },

  updateLpName: {
    desc: '编辑LP名称',
    method: 'put',
    url: 'api/v1/lp/{lp_id}',
    mock: false,
    request: { lp_name: '' },
    response: mock.createFolder,
  },

  deleteLp: {
    desc: 'delete lp',
    method: 'delete',
    url: 'api/v1/lp/{lp_id}',
    mock: false,
    request: {},
    response: mock.createFolder,
  },
  addLpUser: {
    desc: '新增LP用户',
    method: 'post',
    url: 'api/v1/user',
    mock: false,
    request: {
      lp_id: 0,
      account: '',
      group_ids: '',
    },
    response: mock.createFolder,
  },
  deleteLpUser: {
    desc: '删除LP用户',
    method: 'delete',
    url: 'api/v1/user/{user_id}',
    mock: false,
    request: {},
    response: mock.createFolder,
  },
  updateLpUser: {
    desc: '编辑LP用户',
    method: 'put',
    url: 'api/v1/user/{id}',
    mock: false,
    request: {
      account: '',
      group_ids: '',
    },
    response: mock.createFolder,
  },
  getAdminUserList: {
    desc: '获取lp 管理员列表',
    method: 'get',
    url: 'api/v1/users/lp_admin',
    mock: false,
    request: {},
    response: mock.getAllUsers,
  },
  getAllUsersList: {
    desc: '获取批量users列表',
    method: 'get',
    url: 'api/v1/users/tof',
    mock: false,
    request: { rtx_name_en: '' },
    response: mock.getAllUsers,
  },
  addLPAdmin: {
    desc: '增加lp管理员',
    method: 'post',
    url: 'api/v1/users/lp_admin',
    mock: false,
    request: { rtx_id: '' },
    response: mock.createFolder,
  },
  deleteLpAdmin: {
    desc: '删除LP管理员',
    method: 'delete',
    url: 'api/v1/users/lp_admin/{id}',
    mock: false,
    request: {},
    response: mock.createFolder,
  },
  sendWelEmail: {
    desc: '发送欢迎邮件',
    method: 'post',
    url: 'api/v1/users/wel_mail',
    mock: false,
    request: {},
    response: mock.createFolder,
  },
  sendResetEmail: {
    desc: 'lp user重置密码邮件',
    method: 'post',
    url: 'api/v1/users/reset_mail/{id}',
    mock: false,
    request: {},
    response: mock.createFolder,
  },
  getUserAgreement: {
    desc: '获取用户是否同意了最新协议',
    method: 'get',
    url: 'api/ag/agrees',
    mock: false,
    request: { account: '' },
    response: mock.getUserInfo,
  },
  confirmNewAgreement: {
    desc: '签署最新版本的协议',
    method: 'post',
    url: 'api/ag/agrees',
    mock: false,
    request: {},
    response: mock.createFolder,
  },
  getNewestAgreement: {
    desc: '获取最新版本协议',
    method: 'get',
    url: 'api/ag/agreements/newest',
    mock: false,
    request: {},
    response: mock.getUserInfo,
  },
  getLpMonitorLogs: {
    desc: '获取LP监控日志',
    method: 'get',
    url: 'api/v1/users/monitors',
    mock: false,
    request: {},
    response: mock.getLpMonitorLogs,
  },
  exportLpMonitorLogs: {
    desc: '导出LP监控日志',
    method: 'get',
    url: 'api/v1/users/monitor/file',
    mock: false,
    request: {},
  },
  getUsers: {
    desc: '用户列表',
    method: 'get',
    url: 'api/v1/users',
    mock: false,
    request: { account: '' },
  },
});

export default Object.assign({}, config, doc, groups, permissions);
